<template>
    <v-card>
        <v-card-title>
            Tipo Vehículo
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialogForm = true" v-html="'Nuevo'" />

            <v-dialog v-model="dialogForm" max-width="50%" :fullscreen="$root.isTouch"
                :scrollable="$root.isTouch == false" persistent>
                <tipoVehiculoModal :seleccionado="seleccionado" :tituloFormulario="tituloFormulario"
                    :listaGeneral="listaGeneral" />
            </v-dialog>

        </v-card-title>
        <v-container>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado *" color="textbox" v-model="estadoFiltrado"
                        :items="listaGeneral.estado" item-text="nombre_estado" item-value="id_estado" @change="listar"
                        outlined dense />
                </v-col>
                <v-col cols="12" sm="2" />
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" prepend-inner-icon="search" v-model="buscar" color="textbox" clearable
                        dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :headers="listaGeneral.cabecera" :items="listaGeneral.detalle" :search="buscar"
                        class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="editarItem(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>
                        
                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-text="buscar"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name:"TipoVehiculoView",
        components: {
            tipoVehiculoModal: () => import('@/components/catalogo/ModalTipoVehiculoComponent.vue')
        },
        provide: function () {
            return {
                insertarActualizar: this.insertarActualizar,
                cerrarFormulario: this.cerrarFormulario
            }
        },
        watch: {
            listaGeneral() {
                this.estadoFiltrado = this.listaGeneral.estado[0].id_estado;
                this.listar();
            }
        },
        data() {
            return {
                listaGeneral: {},
                buscar: '',
                dialogForm: false,
                seleccionado: {},
                estadoFiltrado: [],
            }
        },

        mounted() {
            this.cargaGeneral();
        },
        computed: {
            tituloFormulario() {
                return this.seleccionado.idTipoVehiculo > "0" ? 'Editar Tipo Vehículo' : 'Nuevo Tipo Vehículo'
            }
        },
        methods: {
            cargaGeneral() {
                axios.post(`${BASE_URI}administrador/tipoVehiculo/cargaGeneral`, {
                        opcion: 'L'
                    })
                    .then((respuesta) => {
                        if (respuesta.status == '200' && respuesta.data
                            .existeError != null) {
                            if (!respuesta.existeError) {
                                this.listaGeneral = respuesta.data.data;
                            } else mensajesAlerta(respuesta.mensaje, 'E');
                        } else mensajesAlerta(mensajeEstandar.errorPeticion, "E");
                    })
                    .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                    });
            },
            editarItem(item) {
                this.seleccionado = Object.assign({}, item),
                    this.dialogForm = true
            },
            cerrarFormulario() {
                this.dialogForm = false
                this.seleccionado = {}
            },
            listar() {
                this.listaGeneral.detalle = [];
                const estado = this.estadoFiltrado;
                axios.post(`${BASE_URI}administrador/tipoVehiculo/listar`, {
                        opcion: 'L',
                        idEstado: estado,
                    })
                    .then((respuesta) => {
                        if (respuesta.status == '200' && respuesta.data
                            .existeError != null) {
                            if (!respuesta.existeError) {
                                this.listaGeneral.detalle = respuesta.data.data;
                            } else mensajesAlerta(respuesta.mensaje, 'W');
                        } else mensajesAlerta(mensajeEstandar.errorPeticion, "E");
                    })
                    .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                    });
            },
            insertarActualizar(_opcion) {
                axios.post(`${BASE_URI}administrador/tipoVehiculo/mantenimiento`, {
                        opcion: _opcion,
                        tipoVehiculo: this.seleccionado
                    })
                    .then((respuesta) => {
                        if (respuesta.status == '200' && respuesta.data
                            .existeError != null) {
                            if (!respuesta.data.existeError) {
                                mensajeAlertaTiempo(respuesta.data.mensaje, (respuesta.data.existeError == false) ? "S" : "E");
                                this.listar();
                            } else mensajesAlerta(respuesta.mensaje, "E");
                        } else mensajesAlerta(mensajeEstandar.errorPeticion, "E");
                    })
                    .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                    });
            }
        }
    }
</script>